/**
 * Created by Pierrot on 08/10/2014.
 */
'use strict';
import * as _ from 'lodash';

module.exports = function (angular) {

    // exemple : [Voir](http://google.fr)
    const RE = /\[([^\]]*)\]\(([^)]*)\)/g;

    return {
        mdlink: function ($sce) {
            return function (value) {
                //console.log(RE.exec(value));
                //console.log(value.replace(RE,'<a href="$1" target="_blank>$2</a>'));
               return $sce.trustAsHtml(value.replace(RE,'<a href="$2" target="_blank">$1</a>'));
            }
        }
    };
};